import { render, staticRenderFns } from "./transferIncome.vue?vue&type=template&id=2ee2f5f8&scoped=true"
import script from "./transferIncome.vue?vue&type=script&lang=js"
export * from "./transferIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee2f5f8",
  null
  
)

export default component.exports